export default "__VITE_ASSET__CgTBEu1P__"